let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aP4eD")).then(() => parcelRequire('bkrR7'));